import React from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route
  } from "react-router-dom";

import SingleMeal from './components/SingleMeal'
//import { Meal} from "./components"; 

// import pages 
import Home from './pages/Home'
import Navbar from './pages/Navbar'
import About from './pages/About'
import Error from './pages/Error'
//TODO
//1. Search for Meals
//2. Display the results
//3. Random / Featured Meals *stopped*
//4. Bookmark: Favorite Recipe


function App() {
  
  return (
    <Router >
      <Navbar />
      <Switch>
        <Route exact path="/">
          <Home />
        </Route>
        <Route path="/about">
          <About />
        </Route>
        <Route path="/meal/:id">
          <SingleMeal />
        </Route>
        <Route path="*">
          <Error />
        </Route>
      </Switch>
    </Router>
    
  );
};

export default App;

